import React from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import { validaInteiroELimitaCampo } from '../../utilities/validaInteiroELimitaCampo'
import { DASHBOARD_TABS } from '../../utilities/dashboard'

const TabPermissions = ({ register, watch, setValue, saveFinancialPeriod, loadingRecuperar }) => {
  const restricted = watch('financial_restricted') === 'true'

  return (
    <Row className="align-items-end">
      <Form.Group as={Col} xs={12} md={4} className="mb-3">
        <Form.Label>Período do Financeiro</Form.Label>
        <Form.Select size='sm' {...register('financial_restricted')}>
          <option value='false'>SEM RESTRIÇÃO</option>
          <option value='true'>RESTRINGIR</option>
        </Form.Select>
      </Form.Group>

      <Form.Group as={Col} xs={12} md={4} className="mb-3">
        <Form.Label>Dias anteriores permitidos</Form.Label>
        <Form.Control
          size='sm'
          type="text"
          autoComplete="off"
          disabled={!restricted}
          {...register('financial_days')}
          onChange={(e) => validaInteiroELimitaCampo(e.target.value, 3, 'financial_days', setValue)}
        />
      </Form.Group>

      <Form.Group as={Col} xs={12} md={4} className="mb-3">
        <Form.Label>Valor total do Financeiro</Form.Label>
        <Form.Select size='sm' {...register('financial_show_total')}>
          <option value='true'>VISUALIZAR</option>
          <option value='false'>OCULTAR</option>
        </Form.Select>
      </Form.Group>

      <Col xs={12}>
        <small style={{ color: 'red' }}>* 0 = somente o dia atual · 1 = hoje e ontem · 2 = hoje e os 2 dias anteriores (máximo 365). Vale na próxima busca do usuário, sem novo login.</small>
        <small className='d-block' style={{ color: 'red' }}>* Valor total: a soma que aparece no fim da lista de Financeiros. Com OCULTAR, o usuário continua vendo a lista e a quantidade de registros.</small>
      </Col>

      <Col xs={12} sm={12} md="auto" className="mt-4">
        <Button className='w-100' variant="success" onClick={saveFinancialPeriod} disabled={loadingRecuperar}>
          {loadingRecuperar === true ?
            <span>
              <Spinner animation="border" size="sm" /> Aguarde...{' '}
            </span>
            :
            <span>Salvar financeiro</span>}
        </Button>
      </Col>
    </Row>
  )
}

// Bloco Dashboard: uma chave por aba. A aba que quem edita não tem fica desligada e travada; se o usuário editado tem uma aba
// que quem edita não tem, o bloco inteiro trava (mesma regra do backend). O administrador vê todas as abas e não é alterado
export const DashboardPermissions = ({ register, loggedTabs, editable, admin, separated, saveDashboardTabs, loadingRecuperar }) => (
  <Row className={`align-items-end ${separated ? 'mt-4 pt-4 border-top' : ''}`}>
    <Col xs={12}>
      <Form.Label className='fw-bold'>Dashboard</Form.Label>
    </Col>

    {DASHBOARD_TABS.map((tab) => (
      <Form.Group as={Col} xs={12} md={4} className="mb-3" key={tab.key}>
        <Form.Check
          type='switch'
          id={'dashboard_tab_' + tab.key}
          label={<>{tab.title} <small className='text-muted'>({tab.description})</small></>}
          disabled={!editable || !loggedTabs.includes(tab.key)}
          {...register('dashboard_tab_' + tab.key)}
        />
      </Form.Group>
    ))}

    <Col xs={12}>
      {admin ? <small className='d-block text-muted mb-1'>O administrador vê todas as abas.</small> : ''}
      {(!admin && !editable) ? <small className='d-block text-muted mb-1'>Este usuário tem abas do Dashboard que você não tem: só quem tem todas elas pode alterar.</small> : ''}
      <small style={{ color: 'red' }}>* Sem nenhuma aba ligada, o usuário não vê o Dashboard. Você só libera ou retira abas que também tem. Vale na próxima chamada; o item do menu aparece ou some quando o usuário recarregar a página (F5), sem novo login.</small>
    </Col>

    <Col xs={12} sm={12} md="auto" className="mt-4">
      <Button className='w-100' variant="success" onClick={saveDashboardTabs} disabled={loadingRecuperar || !editable}>
        {loadingRecuperar === true ?
          <span>
            <Spinner animation="border" size="sm" /> Aguarde...{' '}
          </span>
          :
          <span>Salvar dashboard</span>}
      </Button>
    </Col>
  </Row>
)

export default TabPermissions
